import OcrCamsIntegration from "../app/web/ocr-cams-integration/ocr-cams-integration.jsx";
import ActiveKeys from "../app/web/active-keys/active-keys.jsx";
import IntegrationUsers from "../app/web/integration-users/list/integration-users.jsx";
import IntegrationUsersForm from "../app/web/integration-users/components/integration-users-form.jsx";
import Documentation from "../app/web/documentation/documentation.jsx";
import FormBuilderList from "../app/web/form-builder/list/form-builder-list.jsx";
import FormBuilderPage from "../app/web/form-builder/form/form-builder-page.jsx";
import {requirePermission} from "./middleware.js";
import {PermissionEnum} from "../utils/enums/permission-enum.js";

const RouterDev = () => [
    {
        id: "ocr-cams-integration",
        path: "ocr-cams-integration",
        Component: OcrCamsIntegration,
        loader: requirePermission(PermissionEnum.CONFIGURATION)
    },

    {
        id: "active-keys",
        path: "active-keys",
        Component: ActiveKeys,
        loader: requirePermission(PermissionEnum.CONFIGURATION)
    },

    {
        id: "integration-users",
        path: "integration-users",
        Component: IntegrationUsers,
        loader: requirePermission(PermissionEnum.CONFIGURATION)
    },
    {
        id: "integration-users-form",
        path: "integration-users/form/:id?",
        Component: IntegrationUsersForm,
        loader: requirePermission(PermissionEnum.CONFIGURATION)
    },

    {
        id: "documentation",
        path: "documentation",
        Component: Documentation,
        loader: requirePermission(PermissionEnum.CONFIGURATION)
    },

    {
        id: "form-builder",
        path: "form-builder",
        Component: FormBuilderList,
        loader: requirePermission(PermissionEnum.CONFIGURATION)
    },
    {
        id: "form-builder-form",
        path: "form-builder/form/:id?",
        Component: FormBuilderPage,
        loader: requirePermission(PermissionEnum.CONFIGURATION)
    },
]

export default RouterDev;
